import { sub } from 'date-fns';
//
import { role } from './role';
import { email } from './email';
import { boolean } from './boolean';
import { company } from './company';
import { phoneNumber } from './phoneNumber';
import { fullAddress, country } from './address';
import { firstName, lastName, fullName } from './name';
import { title, sentence, description } from './text';
import { price, rating, age, percent } from './number';

// ----------------------------------------------------------------------

const _mock = {
  id: (index) => `e99f09a7-dd88-49d5-b1c8-1daf80c2d7b${index + 1}`,
  email: (index) => email[index],
  phoneNumber: (index) => phoneNumber[index],
  time: (index) => sub(new Date(), { days: index, hours: index }),
  boolean: (index) => boolean[index],
  role: (index) => role[index],
  company: (index) => company[index],
  address: {
    fullAddress: (index) => fullAddress[index],
    country: (index) => country[index],
  },
  name: {
    firstName: (index) => firstName[index],
    lastName: (index) => lastName[index],
    fullName: (index) => fullName[index],
  },
  text: {
    title: (index) => title[index],
    sentence: (index) => sentence[index],
    description: (index) => description[index],
  },
  number: {
    percent: (index) => percent[index],
    rating: (index) => rating[index],
    age: (index) => age[index],
    price: (index) => price[index],
  },
  image: {
    cover: (index) => `https://minimal-assets-api-dev.vercel.app/assets/images/covers/cover_${index + 1}.jpg`,
    feed: (index) => `https://minimal-assets-api-dev.vercel.app/assets/images/feeds/feed_${index + 1}.jpg`,
    product: (index) => `https://minimal-assets-api-dev.vercel.app/assets/images/products/product_${index + 1}.jpg`,
    avatar: (index) => `https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_${index + 1}.jpg`,
  },
  // mock
  profileFormComponent: {
    "id": "profile",
    "type": "form",
    "name": "applicant's profile",
    "dependencies": [],
    "options": {
      "title": "Applicant's Profile Details",
      "fields": [
        {
          "type": "text",
          "id": "givenName",
          "label": "Given Name",
          "placeholder": "Enter given name",
          "validationType": "string",
          "defaultValue": "",
          "validations": [
            {
              "type": "required",
              "params": [
                "Given name field is required"
              ]
            },
            {
              "type": "trim"
            }
          ]
        },
        {
          "type": "text",
          "id": "middleName",
          "label": "Middle Name",
          "validationType": "string",
          "validators": [
            {
              "type": "trim"
            }
          ]
        },
        {
          "type": "text",
          "id": "lastName",
          "label": "Last Name",
          "validationType": "string",
          "defaultValue": "",
          "validations": [
            {
              "type": "required",
              "params": [
                "Last name field is required"
              ]
            },
            {
              "type": "trim"
            }
          ]
        },
        {
          "type": "date",
          "id": "dateOfBirth",
          "label": "Date of Birth",
          "validationType": "date",
          "validations": [
            {
              "type": "required",
              "params": [
                "Birth date is required"
              ]
            },
            {
              "type": "typeError",
              "params": [
                "Input a valid date."
              ]
            }
          ]
        },
        {
          "type": "text",
          "id": "placeOfBirth",
          "label": "Place of Birth",
          "validationType": "string",
          "defaultValue": "",
          "validations": [
            {
              "type": "required",
              "params": [
                "Birth place field is required"
              ]
            },
            {
              "type": "trim"
            }
          ]
        },
        {
          "type": "text",
          "id": "citizenship",
          "label": "Citizenship",
          "validationType": "string",
          "defaultValue": "",
          "validations": [
            {
              "type": "required",
              "params": [
                "Citizenship field is required"
              ]
            }
          ]
        },
        {
          "type": "text",
          "id": "email",
          "label": "Email",
          "validationType": "string",
          "defaultValue": "",
          "validations": [
            {
              "type": "required",
              "params": [
                "Email is required"
              ]
            },
            {
              "type": "email",
              "params": [
                "Input a valid email."
              ]
            }
          ]
        },
        {
          "type": "text",
          "id": "contactNumber",
          "label": "Contact Number",
          "validationType": "string",
          "defaultValue": "",
          "validations": [
            {
              "type": "required",
              "params": [
                "Contact number is required"
              ]
            },
            {
              "type": "trim"
            }
          ]
        },
        {
          "type": "selection",
          "id": "civilStatus",
          "label": "Civil Status",
          "placeholder": "Select Civil Status",
          "options": {
            "multiple": false,
            "choices": [
              {
                "label": "Single",
                "value": "single"
              },
              {
                "label": "Married",
                "value": "married"
              },
              {
                "label": "Widowed",
                "value": "widowed"
              },
              {
                "label": "Separated",
                "value": "separated"
              },
              {
                "label": "Divorced",
                "value": "divorced"
              }
            ],
            "defaultValue": "",
            "validations": [
              {
                "type": "required",
                "params": [
                  "Please select an option."
                ]
              }
            ]
          },
          "validationType": "string",
          "validations": [
            {
              "type": "required",
              "params": [
                "This field is required"
              ]
            },
            {
              "type": "nullable"
            }
          ]
        },
        {
          "type": "selection",
          "id": "relationship",
          "label": "Relationship with Applicant",
          "placeholder": "Select Relationship with Applicant",
          "validationType": "string",
          "defaultValue": "",
          "validations": [
            {
              "type": "required",
              "params": [
                "Relationship field is required"
              ]
            }
          ],
          "options": {
            "multiple": false,
            "type": "relationship"
          }
        }
      ]
    },
    "status": "active"
  },
};

export default _mock;
